import React from 'react';
import { AccordionItem } from '@here/hds-accordion';
// eslint-disable-next-line no-new
new AccordionItem();
const HDSAccordionItem = React.forwardRef(({ children, disabled, expanded, iconCategory, className, ...rest }, ref) => (React.createElement("hds-accordion-item", { ref: ref, ...(className && { class: className }), ...(disabled && { disabled }), ...(expanded && { expanded }), ...(iconCategory && { 'icon-category': iconCategory }), ...rest }, children)));
HDSAccordionItem.defaultProps = {
    disabled: false,
    headline: '',
    expanded: false,
    iconCategory: 'core-ui',
};
export default HDSAccordionItem;
//# sourceMappingURL=HDSAccordionItem.js.map